import { push } from "connected-react-router";
import { memo, ReactElement, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { Grid } from "../../components/Grid";
import { Redirect } from "../../components/Redirect";
import { selectUserData } from "../../components/appData.slice";
import { FormType } from "../../components/enums";
import {
  useHideFooter,
  usePreventRefresh,
  useScrollDocument,
  useSetFormType,
  useShouldRedirectToHomepage,
} from "../../hooks";
import { Url } from "../../router/enums";
import { GenericScreen } from "../GenericScreen";
import { selectIsFormValidated } from "../Welcome/welcome.selectors";

import styles from "./GenericPreload.module.scss";

type GenericPreloadProps = {
  readonly children?: ReactElement | Array<ReactElement>;
  readonly form: FormType;
  readonly redirection: Url;
};

export const GenericPreload = memo<GenericPreloadProps>(
  ({ form, redirection }) => {
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
    //JIRA AYV-20
    const { trigger } = useFormContext();
    const dispatch = useDispatch();
    const handleOnClick = async () => {
      const isValid = await trigger();
      if (isCaptchaVerified && isValid) {
        dispatch(push(redirection));
      }
    };
    useSetFormType(form);
    //JIRA LPPLWEBMOB-749
    const userData = useSelector(selectUserData);
    const { login, name, surname } = userData;
    const history = useHistory();
    const referrer = document.referrer;
    const isDirectEntry =
      history.action === "PUSH" && !referrer.includes(window.location.origin);

    // if (!isDirectEntry && !login) {
    //   history.replace(Url.WELCOME);
    // }
    //useShouldRedirectToHomepage(selectIsFormValidated);
    useHideFooter();
    useScrollDocument();
    usePreventRefresh();

    return (
      <form className={styles.form}>
        <Grid className={styles.recaptcha}>
          <ReCAPTCHA
            sitekey="6LejGpwUAAAAAHtimyAje8UomkTJztP_gIq4Z2VT"
            onChange={() => setIsCaptchaVerified(true)}
          />
        </Grid>
        <Button
          disabled={!isCaptchaVerified}
          color="primary"
          spacingTop={5}
          variant="contained"
          onClick={handleOnClick}
        >
          Wyślij formularz
        </Button>
      </form>
    );
  }
);
